type DeviceInfo = {
  browser: "chrome" | "firefox" | "safari" | "opera" | "edge" | null;
  device: "android" | "ios" | null;
  iOSversion: number | null;
  isTouchDevice: boolean;
};

export const useDetectDevice = (): DeviceInfo => {
  const { userAgent, platform } = navigator;

  const getBrowser = () => {
    if (userAgent.match(/chrome|chromium|crios/i)) {
      return "chrome";
    }
    if (userAgent.match(/firefox|fxios/i)) {
      return "firefox";
    }
    if (userAgent.match(/safari/i)) {
      return "safari";
    }
    if (userAgent.match(/opr\//i)) {
      return "opera";
    }
    if (userAgent.match(/edg/i)) {
      return "edge";
    }

    return null;
  };

  const getDevice = () => {
    if (/android/i.test(userAgent)) {
      return "android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "ios";
    }
    // Додаткова перевірка для iPad на Safari
    if (platform === "MacIntel" && navigator.maxTouchPoints > 1) {
      return "ios";
    }
    return null;
  };

  const getIOSversion = () => {
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      const v = "Version/";
      return Number(
        userAgent.slice(userAgent.indexOf(v) + v.length).split(".")[0],
      );
    }
    return null;
  };

  const isTouchDevice = () => {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  };

  return {
    browser: getBrowser(),
    device: getDevice(),
    iOSversion: getIOSversion(),
    isTouchDevice: isTouchDevice(),
  };
};
